import { render, staticRenderFns } from "./TopSeaKeywordsGrid.vue?vue&type=template&id=88d719d8&scoped=true&"
import script from "./TopSeaKeywordsGrid.vue?vue&type=script&lang=js&"
export * from "./TopSeaKeywordsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d719d8",
  null
  
)

/* custom blocks */
import block0 from "@/javascripts/grid.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fapp%2Fjavascript%2Fpages%2FDomainSearch%2FOpportunityAndSea%2FTopSeaKeywordsGrid.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./TopSeaKeywordsGrid.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports